import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=e3afae44&scoped=true"
import script from "./DoctorTable.vue?vue&type=script&lang=js"
export * from "./DoctorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3afae44",
  null
  
)

export default component.exports